module.exports = __webpack_public_path__ + "img/ff2.be0522f8.jpg";